import React from "react";
import { Box, Typography, Container } from "@mui/material";
import iconLeaf from "../images/content.png";
import HealthAndFitness from "./HealthAndFitness";
import classImg from "../images/class.jpeg";

const Classes = () => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        minHeight: "100vh",
        mt: 4, // Shifts content upward slightly
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
        fontFamily: "'Playfair Display', serif", // Global for container
      }}
    >
      <Box
        component="img"
        src={iconLeaf}
        alt="Yoga Icon"
        sx={{
          width: "150px",
          height: "150px",
        }}
      />
      <Typography variant="h6" sx={{ color: "#d81b60", mb: 2, fontFamily: "'Playfair Display', serif", }}>
        Classes
      </Typography>
      {/* <Typography
        variant="h1"
        sx={{
          fontWeight: 400,
          color: "#000",
          mb: 4,
          letterSpacing: "1px",
          fontFamily: "'Playfair Display', serif",
        }}
      >
        Yoga For Your Health
      </Typography>
      <Typography
        variant="h6"
        sx={{
          maxWidth: "800px",
          color: "#666",
          mb: 4,
          lineHeight: 1.6,
          fontFamily: "'Playfair Display', serif",
        }}
      >
        Yoga is the union of body, mind, and soul. It's the practice to attain
        self-realization. Regular practice of Yoga, we can say goodbye to
        Doctors, Medicines and Hospitals. Yoga is the master key to the joy,
        peace and gift of God.
      </Typography> */}
      <HealthAndFitness />
      <Box
        component="img"
        src={classImg}
        alt="Yoga Icon"
        sx={{
          my: 4,
          width: "100%",
          height: "600px",
        }}
      />
    </Container>
  );
};

export default Classes;
